'use strict';
var $ = require('jquery'),
    forEach = require('../utils/foreach'),
    generateCid = require('../utils/cid-generator'),
    toObservable = require('../utils/observable'),
    getCidFormDom = require('../utils/get-cid-from-dom'),
    setCidToDom = require('../utils/set-cid-to-dom'),
    eventsAPI = require('./events-api'),
    propsLoad = require('./props-load'),
    componentFinder = require('./finder'),
    ChildStore = require('./child-store'),
    _placeholderClass = 'component-placeholder';

function _placeholderTpl(tagName, cid) {
    return '<' + tagName + ' class="' + _placeholderClass + '" data-placeholder-cid="' + cid + '"></' + tagName + '>';
}

function _filterComponentElements($el, componentName) {
    return $el.filter('[data-component=' + componentName + '],[data-name=' + componentName + ']').filter(function () {
        return !getCidFormDom(this);
    });
}

module.exports = {
    events: {},
    components: {},
    state: {},
    tpl: null,
    initialize: null,
    _init: function (props, opt) {
        opt = opt || {};

        this.cid = generateCid();
        this.parent = opt.parent;
        this.childs = new ChildStore(this.components, this.state);
        this.props = props || {};
    },
    doMount: function (el) {
        var _this = this;

        this.$el = $(el);

        if (!this.$el.length) {
            throw new Error(this.cid, ' don\'t have a root element.');
        }
        propsLoad(this.props, this.$el[0]);

        forEach(this.$el, function (el) {
            setCidToDom(el, _this.cid);
        }, this);
        toObservable(this, this.$el);
        this.findComponents();
        eventsAPI(this, this.events);
        if (this.initialize) {
            this.initialize(this.props);
        }
    },
    doRender: function (props) {
        var $el = this.render(props || this.props);

        //Try to re-render the content
        if (this.$el && this.$el.length) {
            if (this.$el.length > 1) {
                throw new Error('Expected root element, collection given.', this.cid + ' can\'t be re-rendered.');
            }
            this.$el.html($el.html());
        } else {
            this.doMount($el);
        }

    },
    render: function (props) {
        var $el,
            html;
        props._this = this;

        html = this.tpl(props);
        $el = $(html);
        this.placeComponents($el);

        return $el;
    },
    set: function (key, val) {
        var _this = this,
            attrs;

        if (!key) {
            return this;
        }

        // Handle both `"key", value` and `{key: value}` -style arguments.
        if (typeof key === 'object') {
            attrs = key;
        } else {
            (attrs = {})[key] = val;
        }

        forEach(attrs, function (value, key) {
            var child;

            if (key) {
                child = _this.childs.get(key);

                if (child) {
                    if (_this.childs.definition.isState(key)) {
                        child.set.call(_this, value);
                    } else {
                        child.set(value);
                    }
                }
            }
        });
    },
    get: function (key) {
        var _this = this,
            results,
            child;

        if (!key) {
            results = {};
            forEach(_this.childs.get(), function (child, key) {
                if (_this.childs.definition.isState(key)) {
                    results[key] = child.get.call(_this);
                } else {
                    results[key] = child.get();
                }
            });
        } else {
            child = _this.childs.get(key);

            if (child) {
                if (_this.childs.definition.isState(key)) {
                    results = child.get.call(_this);
                } else {
                    results = child.get();
                }
            }
        }

        return results;
    },
    getNewChild: function (name, props) {
        var Component = this.childs.definition.getComponentClass(name);

        if (!Component) {
            throw new Error('The child ' + name + ' does not exist');
        }

        return new Component(props, {parent: this});
    },
    findComponents: function () {
        var _this = this,
            $childsEls;

        if (this.childs.definition.hasComponents()) {
            $childsEls = $(componentFinder(this.$el));

            if ($childsEls.length) {
                forEach(this.childs.definition.getComponentsNames(), function (name) {
                    var $el = _filterComponentElements($childsEls, name);

                    if ($el.length) {
                        forEach($el, function (el) {
                            var component = _this.getNewChild(name);
                            component.doMount(el);
                            _this.childs.add(name, component);
                        });
                    }
                });
            }
        }
    },
    preRenderComponent: function (props) {
        var name = props.componentName,
            component,
            tagName;

        component = this.getNewChild(name, props);
        component.doRender();

        this.childs.add(name, component);
        tagName = component.$el[0].tagName;
        return _placeholderTpl(tagName.toLowerCase(), component.cid);
    },
    placeComponents: function ($el) {
        var _this = this;
        forEach($el.find('.' + _placeholderClass), function (el) {
            var $placeholder = $(el),
                cid = $placeholder.attr('data-placeholder-cid'),
                component = _this.childs.get(cid, true);

            component.$el.insertBefore($placeholder);
            $placeholder.remove();
        });
    },
    detach: function () {
        this.$el.detach();
    },
    detachComponents: function () {
        var _this = this;
        forEach(this.childs.get(), function (component, name) {
            if (_this.childs.definition.isComponent(name)) {
                component.detach();
            }
        });
    },
    remove: function () {
        this.removeComponents();
        this.off();
        this.$el.remove();

        if (this._observed) {
            this._observed.off();
        }
    },
    removeComponent: function (name) {
        this.childs.remove(name);
    },
    removeComponents: function () {
        this.childs.remove();
    }
};
